import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { GraduationCap, Coffee, Dumbbell, Utensils, Building2, Sparkles, Radio } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ICONS = {
  Schools: GraduationCap,
  Cafés: Coffee,
  Cafes: Coffee,
  Gyms: Dumbbell,
  Restaurants: Utensils,
  "Business Websites": Building2,
  Boutiques: Sparkles,
};

const PipelineTicker = () => {
  const [pipeline, setPipeline] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${BACKEND_URL}/api/pipeline`)
      .then((r) => {
        if (mounted) setPipeline(r.data);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  if (!pipeline) return null;
  const industries = pipeline.industries || [];

  return (
    <section
      data-testid="pipeline-ticker"
      className="relative border-y border-white/[0.06] bg-[#08080a] py-8"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div className="flex items-center gap-4">
            <div className="relative">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--gold)] opacity-60" />
              <span className="relative grid h-3 w-3 place-items-center rounded-full bg-[var(--gold-bright)]">
                <Radio className="hidden" />
              </span>
            </div>
            <div>
              <div className="font-mono-label text-[var(--gold)]">
                Currently Building
              </div>
              <motion.div
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mt-1 font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl"
              >
                <span className="gold-gradient-text">{pipeline.active_projects}</span>{" "}
                Active Projects · Across{" "}
                <span className="gold-gradient-text">{industries.length}</span> industries
              </motion.div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 lg:gap-3">
            {industries.map((ind, i) => {
              const Icon = ICONS[ind] || Building2;
              return (
                <motion.div
                  key={ind}
                  initial={{ opacity: 0, y: 8 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.02] px-3.5 py-1.5 text-[12.5px] text-zinc-300"
                >
                  <Icon className="h-3.5 w-3.5 text-[var(--gold-bright)]" strokeWidth={1.7} />
                  {ind}
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PipelineTicker;
